export default __webpack_public_path__ + "static/media/monkey12.f958b6d9.jpeg";